import { render } from "./ProfileArea.vue?vue&type=template&id=6f66ca20&scoped=true"
import script from "./ProfileArea.vue?vue&type=script&lang=js"
export * from "./ProfileArea.vue?vue&type=script&lang=js"

import "./ProfileArea.vue?vue&type=style&index=0&id=6f66ca20&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f66ca20"

export default script